var EditLinkToggle = React.createClass({
  propTypes: {
    editEnabled: React.PropTypes.bool.isRequired,
    onClick: React.PropTypes.func.isRequired,
    className: React.PropTypes.string
  },
  render() {
    let {
      editEnabled,
      className
    } = this.props;
    let children;

    if (this.props.editEnabled) {
      children = Labels.getLabel("Done");
    } else {
      children = (
        <span>
          <span className="glyphicon glyphicon-pencil"></span> <span className="icon-link__text">{Labels.getLabel("Edit")}</span>
        </span>
      )
    }

    return (
      <a href="#" className={classNames({"icon-link": !editEnabled}, {"btn btn-default": !editEnabled}, {"btn btn-primary": editEnabled}, className)} role="button" onClick={this.props.onClick}>
        {children}
      </a>
    )
  }
})